import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "題目",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "選項",
    isNumber: true,
    isSum: true,
  },
];

export const WorkQualityToNutrition = {
  label: "工作性質 vs 營養管理",
  key: "WorkQualityToNutrition",
  path: "BMI/WorkQualityToNutrition",
  api: "TCS_V_BMIHENutritionV",
  render: (options) => <Diagram.BMI.WorkQualityToNutrition {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "工作性質",
      field: "工作性質",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
